import React, { useEffect, useState } from "react";
import SidebarLayout from './SidebarLayout';
import { Row, Col, Card, Typography, Divider, Spin, message } from "antd";
import _BankerService from "../../modules/BankerService";
import moment from "moment";
import _commonService from "../../modules/commonService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import ApplicationList from "./ApplicationList";
import { useLocation } from "react-router-dom";
import {SENIOR_PRIVATE_BANKER_ROLE_ID, UNDERWRITER_BANKER_ROLE} from "../../constants/DataConstants";

const { Title, Text } = Typography;

const LoanApplications = () => {
  // const [monthlySummary, setMonthlySummary] = useState({});
  const [loanApplications, setLoanApplications] = useState([]);
  const bankerIdRaw = localStorage.getItem("BankerId");
  const BankerId = bankerIdRaw ? parseInt(bankerIdRaw) : null;
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [applicationStatus, setApplicationStatus] = useState();

  // const bankerRoleId = localStorage.getItem("RoleId");
  // const isBanker = bankerRoleId === 3 ? true : false;

  const bankerRoleId = Number(localStorage.getItem("RoleId") ?? 0);
  const isBanker = bankerRoleId === SENIOR_PRIVATE_BANKER_ROLE_ID;
  const isUnderwriterBanker = localStorage.getItem("userRole") === UNDERWRITER_BANKER_ROLE;

  const location = useLocation();
  let data = location.state;
  let appStatusFlag = 0;
  if (data && data.applicationStatusFlag) {
    appStatusFlag = data.applicationStatusFlag;
  }

  const [applicationStatusFilter] = useState(appStatusFlag);

  useEffect(() => {
    setApplicationStatus(applicationStatusFilter);
  }, [applicationStatusFilter]);

  // useEffect(() => {
  //   getBankerLoanApplicationMonthlySummaryByBankerId();
  // }, []);

  useEffect(() => {
    getAllLoanApplicationListByBankerId();
  }, [debouncedSearchText, applicationStatus, toDate, sortBy, pageIndex, pageSize]);


  useEffect(() => {
    if (debouncedSearchText !== "") {
      setPageIndex(1);
      setPageSize(10);
    }
  }, [debouncedSearchText]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchTerm && searchTerm.trim());
    }, 900);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // const getBankerLoanApplicationMonthlySummaryByBankerId = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await _BankerService.getBankerLoanApplicationMonthlySummaryByBankerId(BankerId);
  //     if (res?.data?.IsSuccess && res.data.Obj) {
  //       setLoading(false);
  //       setMonthlySummary(res.data.Obj);
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching monthly summary:", error);
  //   }
  // };

  const getAllLoanApplicationListByBankerId = async () => {

    // debugger;
    if ((applicationStatus != undefined || applicationStatus == 0)) {
      const params = {
        bankerId: BankerId,
        isBanker: isBanker,
        ByAppStatus: applicationStatus,
        startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
        endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
        pageIndex,
        pageSize,
        searchTerm: debouncedSearchText,
        sortBy,
        sortAsc: true
       
      };
      setLoading(true);
      try {
        const resObj = isUnderwriterBanker
          ? await _BankerService.getAllLoanApplicationListByUnderwriterBankerId(params)
          : await _BankerService.getAllLoanApplicationListByBankerId(params);

        if (
          resObj?.data?.IsSuccess &&
          resObj.data.Obj &&
          Array.isArray(resObj.data.Obj.List)
        ) {
          setLoanApplications(resObj.data.Obj.List);
          setTotalCount(resObj.data.Obj.TotalRecords || 0);
          setLoading(false);
        } else {
          message.error(resObj.data.Message || COMMON_ERROR_MSG)
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching loan applications:", error);
        setLoading(false);
      }
    }
  };

  const currentMonthYear = _commonService.getCurrentMonthAndYear();

  const handleClearFilters = () => {
    setSearchTerm("");
    setFromDate(null);
    setToDate(null);
    setSortBy(null);
    setApplicationStatus(0);
    setPageIndex(1);
    setPageSize(10);
  };

  const handlePaginationChange = (page, size) => {
    setPageIndex(page);
    setPageSize(size);
  };

  const handleApplicationStatusChange = (value) => {
    setApplicationStatus(value);
    setPageIndex(1);
  };

  const handleFromDateChange = (value) => {
    setFromDate(value);
    setPageIndex(1);
  };

  const handleToDateChange = (value) => {
    setToDate(value);
    setPageIndex(1);
  };

  const handleSortChange = (value) => {
    setSortBy(value);
    setPageIndex(1);
  };

  return (
    <Spin spinning={loading}>
      <SidebarLayout>

        {/* <Title level={3}>All Applications</Title> */}
        {/* <Title level={5}>Monthly Review, {currentMonthYear}</Title> */}


        {/* <div>
         <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
           <Col xs={24} md={12}>
              <Card className="cardStyle" bodyStyle={{ minHeight: 120, padding: "16px" }}>
                <Row gutter={[0, 12]}>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text style={{ color: "#8A94A6" }}>All Applications</Text>
                      <Text strong style={{ color: "#222" }}>{monthlySummary.AllApplications}</Text>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text style={{ color: "#8A94A6" }}>New Applications </Text>
                      <Text strong style={{ color: "#222" }}>{monthlySummary.NewApplications}</Text>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text style={{ color: "#8A94A6" }}>Reviewed Applications</Text>
                      <Text strong style={{ color: "#222" }}>{monthlySummary.ReviewedApplications}</Text>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text style={{ color: "#8A94A6" }}>Action Required </Text>
                      <Text strong style={{ color: "#222" }}>{monthlySummary.ActionRequested}</Text>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text style={{ color: "#8A94A6" }}>Approved Applications </Text>
                      <Text strong style={{ color: "#222" }}>{monthlySummary.ApprovedApplications}</Text>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className="cardStyle" bodyStyle={{ minHeight: 120, padding: "16px" }}>
                <Row gutter={[0, 12]}>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text strong style={{ color: "#222",fontSize:16}}>Total Loan Program Amount</Text>
                      <Text strong style={{ color: "#222" }}>
                        $ {_commonService.formatNumberWithCommas(monthlySummary.TotalLoanProgrameAmount)}
                      </Text>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text strong style={{ color: "#222",fontSize:16}}>Remaining Amount</Text>
                      <Text strong style={{ color: "#222" }}>
                        $ {_commonService.formatNumberWithCommas(monthlySummary.RemainingAmount)}
                      </Text>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Text strong style={{ color: "#222",fontSize:16}}>Utilized Amount</Text>
                      <Text strong style={{ color: "#222" }}>
                        $ {_commonService.formatNumberWithCommas(monthlySummary.UtilizedAmount)}
                      </Text>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div> */}

        <div style={{ marginBottom: 24 }}>
          <ApplicationList
            allApplications={loanApplications}
            loading={loading}
            pageIndex={pageIndex}
            pageSize={pageSize}
            totalCount={totalCount}
            onPaginationChange={handlePaginationChange}
            searchTerm={searchTerm}
            fromDate={fromDate}
            toDate={toDate}
            sortBy={sortBy}
            onSearchChange={setSearchTerm}
            fromDateChange={handleFromDateChange}
            toDateChange={handleToDateChange}
            onSortChange={handleSortChange}
            onClearFilters={handleClearFilters}
            onApplicationStatusChange={handleApplicationStatusChange}
            applicationStatusForFilter={applicationStatus}
          />
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default LoanApplications;